import * as React from 'react';
import React__default from 'react';
import classnames from 'classnames';
import Link from 'next/link';
import Image from 'next/image';
import { createPortal } from 'react-dom';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var ButtonVariant;
(function (ButtonVariant) {
  ButtonVariant["DEFAULT_DARK"] = "DefaultDark";
  ButtonVariant["DEFAULT_LIGHT"] = "DefaultLight";
  ButtonVariant["INVERSE_DARK"] = "InverseDark";
  ButtonVariant["INVERSE_LIGHT"] = "InverseLight";
})(ButtonVariant || (ButtonVariant = {}));
var LifePageNavItem;
(function (LifePageNavItem) {
  LifePageNavItem[LifePageNavItem["OBITUARY"] = 0] = "OBITUARY";
  LifePageNavItem[LifePageNavItem["MEMORIES"] = 1] = "MEMORIES";
  LifePageNavItem[LifePageNavItem["SERVICES"] = 2] = "SERVICES";
  LifePageNavItem[LifePageNavItem["FLOWERS"] = 3] = "FLOWERS";
  LifePageNavItem[LifePageNavItem["MEMORIAL_TREES"] = 4] = "MEMORIAL_TREES";
})(LifePageNavItem || (LifePageNavItem = {}));
var LocationIdentifier;
(function (LocationIdentifier) {
  LocationIdentifier["LOCATION1"] = "location1";
  LocationIdentifier["LOCATION2"] = "location2";
  LocationIdentifier["UNKNOWN"] = "unknown";
})(LocationIdentifier || (LocationIdentifier = {}));
var Reactable;
(function (Reactable) {
  Reactable["OBITUARY_MEMORY"] = "ObituaryMemory";
  Reactable["OBITUARY_MEMORY_COMMENT"] = "ObituaryMemoryComment";
})(Reactable || (Reactable = {}));
var ShippingFormVariant;
(function (ShippingFormVariant) {
  ShippingFormVariant["LOCATION_1"] = "location1";
  ShippingFormVariant["LOCATION_2"] = "location2";
  ShippingFormVariant["CUSTOM"] = "custom";
})(ShippingFormVariant || (ShippingFormVariant = {}));
var LightDarkVariant;
(function (LightDarkVariant) {
  LightDarkVariant["LIGHT"] = "light";
  LightDarkVariant["DARK"] = "dark";
})(LightDarkVariant || (LightDarkVariant = {}));

var _excluded$5 = ["children", "className", "variant", "as"],
  _excluded2$1 = ["href"];
var OvalButton = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    variant = _ref.variant,
    as = _ref.as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var btnClass = classnames('OvalButton', "OvalButton-btn--" + variant, className, {
    'OvalButton-anchor': !!as
  });
  if (as === 'anchor') {
    return React__default.createElement("a", _extends({}, rest, {
      className: btnClass,
      ref: ref
    }), children);
  }
  if (as === 'Link') {
    var href = rest.href,
      linkProps = _objectWithoutPropertiesLoose(rest, _excluded2$1);
    return React__default.createElement(Link, {
      href: href || ''
    }, React__default.createElement("a", _extends({}, linkProps, {
      className: btnClass
    }), children));
  }
  return React__default.createElement("button", _extends({
    className: btnClass
  }, rest, {
    ref: ref
  }), children);
});
OvalButton.displayName = 'OvalButton';

var _excluded$4 = ["className", "productCount", "ref"];
var BasketButton = function BasketButton(_ref) {
  var className = _ref.className,
    productCount = _ref.productCount,
    ref = _ref.ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  return React__default.createElement(OvalButton, _extends({}, rest, {
    className: classnames('BasketButton', className),
    "data-product-count": productCount,
    as: "button",
    ref: ref,
    type: "button",
    variant: ButtonVariant.DEFAULT_DARK
  }), "Basket");
};

var EmptyText = function EmptyText(_ref) {
  var body = _ref.body,
    header = _ref.header;
  return React.createElement(React.Fragment, null, React.createElement("h4", {
    className: "h4"
  }, header), React.createElement("p", {
    className: "body"
  }, body));
};

var Spacer = function Spacer(props) {
  var _classnames;
  var spacerClass = classnames((_classnames = {}, _classnames["spacer-horizontal" + props.horizontal] = props.horizontal, _classnames["spacer-horizontalLeft" + props.horizontalLeft] = props.horizontalLeft, _classnames["spacer-horizontalRight" + props.horizontalRight] = props.horizontalRight, _classnames["spacer-horizontalMd" + props.horizontalMd] = props.horizontalMd, _classnames["spacer-horizontalMdLeft" + props.horizontalMdLeft] = props.horizontalMdLeft, _classnames["spacer-horizontalMdRight" + props.horizontalMdRight] = props.horizontalMdRight, _classnames["spacer-vertical" + props.vertical] = props.vertical, _classnames["spacer-verticalBottom" + props.verticalBottom] = props.verticalBottom, _classnames["spacer-verticalTop" + props.verticalTop] = props.verticalTop, _classnames["spacer-verticalMd" + props.verticalMd] = props.verticalMd, _classnames["spacer-verticalMdBottom" + props.verticalMdBottom] = props.verticalMdBottom, _classnames["spacer-verticalMdTop" + props.verticalMdTop] = props.verticalMdTop, _classnames["spacer-verticalLg" + props.verticalLg] = props.verticalLg, _classnames["spacer-verticalLgBottom" + props.verticalLgBottom] = props.verticalLgBottom, _classnames["spacer-verticalLgTop" + props.verticalLgTop] = props.verticalLgTop, _classnames['spacer-inline'] = props.inline, _classnames));
  return React__default.createElement("div", {
    className: spacerClass
  }, props.children);
};

var _excluded$3 = ["children", "className"],
  _excluded2 = ["children", "className"],
  _excluded3 = ["children", "className"],
  _excluded4 = ["children", "className"],
  _excluded5 = ["children", "className"];
var GridImageWrapper = function GridImageWrapper(_ref) {
  var children = _ref.children,
    className = _ref.className,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return React__default.createElement("div", _extends({
    className: classnames('GridImageWrapper-outer', className)
  }, rest), React__default.createElement("div", {
    className: "GridImageWrapper-inner"
  }, React__default.createElement("div", {
    className: "GridImageWrapper-child"
  }, children)));
};
var GridItem = function GridItem(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return React__default.createElement("div", _extends({
    className: classnames('GridItem', className)
  }, rest), children);
};
var GridSubTitle = function GridSubTitle(_ref3) {
  var children = _ref3.children,
    className = _ref3.className,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  return React__default.createElement("p", _extends({
    className: classnames('small', className)
  }, rest), children);
};
var GridTitle = function GridTitle(_ref4) {
  var children = _ref4.children,
    className = _ref4.className,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded4);
  return React__default.createElement(Spacer, {
    verticalTop: "xs"
  }, React__default.createElement("h6", _extends({
    className: classnames('h6', className)
  }, rest), children));
};
var GridWrapper = function GridWrapper(_ref5) {
  var children = _ref5.children,
    className = _ref5.className,
    rest = _objectWithoutPropertiesLoose(_ref5, _excluded5);
  return React__default.createElement("section", _extends({
    className: classnames('GridWrapper', className)
  }, rest), children);
};
var Grid = {
  ImageWrapper: GridImageWrapper,
  Item: GridItem,
  Title: GridTitle,
  SubTitle: GridSubTitle,
  Wrapper: GridWrapper
};

var Wrapper$1 = function Wrapper(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return React__default.createElement("div", {
    className: classnames('Highlight', className)
  }, children);
};
var Primary = function Primary(_ref2) {
  var children = _ref2.children,
    className = _ref2.className;
  return React__default.createElement("div", {
    className: classnames('Highlight-primary', className)
  }, children);
};
var Secondary = function Secondary(_ref3) {
  var children = _ref3.children,
    className = _ref3.className;
  return React__default.createElement("div", {
    className: classnames('Highlight-secondary', className)
  }, children);
};
var Highlight = {
  Primary: Primary,
  Secondary: Secondary,
  Wrapper: Wrapper$1
};

var ImageCard = function ImageCard(_ref) {
  var children = _ref.children,
    className = _ref.className,
    imageAlt = _ref.imageAlt,
    imageURL = _ref.imageURL;
  return React.createElement("div", {
    className: classnames('ImageCard', className)
  }, !!imageURL && React.createElement("div", {
    className: "ImageCard-left"
  }, React.createElement("div", {
    className: "ImageCard-imageWrapper"
  }, React.createElement(Image, {
    alt: imageAlt,
    objectPosition: "top left",
    objectFit: "contain",
    layout: "fill",
    src: imageURL
  }))), React.createElement("div", {
    className: "ImageCard-right"
  }, children));
};

var Loading = function Loading(_ref) {
  var src = _ref.src;
  return React__default.createElement("div", {
    className: "Loading"
  }, React__default.createElement(Image, {
    alt: "loading",
    height: 150,
    src: src,
    width: 150
  }));
};

var _excluded$2 = ["children", "className", "isCentered", "maxWidth"];
var MaxWidthConstraint = function MaxWidthConstraint(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$isCentered = _ref.isCentered,
    isCentered = _ref$isCentered === void 0 ? true : _ref$isCentered,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 1024 : _ref$maxWidth,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return React__default.createElement("div", _extends({}, rest, {
    className: classnames(className, {
      centered: isCentered
    }),
    style: {
      maxWidth: maxWidth
    }
  }), children);
};

var ModalCloseButton = function ModalCloseButton(props) {
  return React.createElement("button", _extends({}, props, {
    "aria-label": "close modal",
    className: "ModalCloseButton",
    type: "button"
  }), React.createElement("div", {
    className: "ModalCloseButton-xUp"
  }, React.createElement("div", {
    className: "ModalCloseButton-xDown"
  })));
};

var ModalWrapper = function ModalWrapper(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$noScrollClassNam = _ref.noScrollClassName,
    noScrollClassName = _ref$noScrollClassNam === void 0 ? 'no-scroll' : _ref$noScrollClassNam,
    onClose = _ref.onClose;
  var clickOutside = React.useCallback(function (event) {
    if (!event.target) {
      return;
    }
    var target = event.target;
    var clickWasOutsideModal = !target.closest('.Modal-outer');
    // The button that was clicked could be removed from the DOM
    // at this point and we don't want that to dismiss the modal.
    var elementIsInDOM = document.body.contains(target);
    if (clickWasOutsideModal && elementIsInDOM) {
      document.body.classList.remove(noScrollClassName);
      onClose();
    }
  }, [noScrollClassName, onClose]);
  React.useEffect(function () {
    document.body.classList.add(noScrollClassName);
    document.addEventListener('mouseup', clickOutside);
    return function () {
      document.body.classList.remove(noScrollClassName);
      document.removeEventListener('mouseup', clickOutside);
    };
  }, [clickOutside, noScrollClassName]);
  return React.createElement("div", {
    className: classnames('ModalWrapper', className)
  }, React.createElement("div", null, children));
};

var Modal = function Modal(_ref) {
  var children = _ref.children,
    noScrollClassName = _ref.noScrollClassName,
    onClose = _ref.onClose;
  var _React$useState = React.useState(false),
    mounted = _React$useState[0],
    setMounted = _React$useState[1];
  var portalLocation = document.getElementById('modal-wrapper') || document.body;
  React.useEffect(function () {
    setMounted(true);
    return function () {
      return setMounted(false);
    };
  }, []);
  return mounted ? createPortal(React.createElement(ModalWrapper, {
    noScrollClassName: noScrollClassName,
    onClose: onClose
  }, React.createElement("div", {
    className: "Modal Modal-outer"
  }, React.createElement(ModalCloseButton, {
    onClick: function onClick() {
      return onClose();
    }
  }), React.createElement("div", {
    className: "Modal-inner"
  }, children))), portalLocation) : null;
};

var _excluded$1 = ["className", "children"];
var OneByFourGrid = function OneByFourGrid(_ref) {
  var className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  return React__default.createElement("div", _extends({}, rest, {
    className: classnames('OneByFourGrid', className)
  }), children);
};

var OneByThreeGrid = function OneByThreeGrid(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return React__default.createElement("div", {
    className: classnames('OneByThreeGrid', className)
  }, children);
};

var PhotoHero = function PhotoHero(_ref) {
  var children = _ref.children;
  return React__default.createElement("div", {
    className: "PhotoHero"
  }, React__default.createElement("h1", {
    className: "PhotoHero-h1 h1"
  }, children));
};

var tabContext = {
  activeTab: '',
  setActiveTab: function setActiveTab() {}
};
var Context = /*#__PURE__*/React.createContext(tabContext);
var Wrapper = function Wrapper(props) {
  var _React$useState = React.useState(props.initialActiveTab),
    activeTab = _React$useState[0],
    setActiveTab = _React$useState[1];
  return React.createElement(Context.Provider, {
    value: {
      activeTab: activeTab,
      setActiveTab: setActiveTab
    }
  }, props.children);
};
var List = function List(props) {
  return React.createElement("ul", {
    className: "Tab-List",
    role: "tablist"
  }, props.children);
};
var Item = function Item(props) {
  var _React$useContext = React.useContext(Context),
    activeTab = _React$useContext.activeTab,
    setActiveTab = _React$useContext.setActiveTab;
  var isActive = activeTab === props.controlsContentId;
  return React.createElement("li", {
    className: "Tab-Item"
  }, React.createElement(Link, {
    href: props.href
  }, React.createElement("a", {
    "aria-controls": props.controlsContentId,
    "aria-selected": isActive,
    className: classnames('Tab-Link', {
      'Tab-Link--Active': isActive
    }),
    id: "tab-" + props.controlsContentId,
    onClick: function onClick() {
      return setActiveTab(props.controlsContentId);
    },
    role: "tab"
  }, props.children)));
};
var Content = function Content(props) {
  var _React$useContext2 = React.useContext(Context),
    activeTab = _React$useContext2.activeTab;
  var isActive = activeTab === props.id;
  return React.createElement("div", {
    className: classnames('Tab-Content', {
      hidden: !isActive
    }),
    "aria-labelledby": "tab-" + props.id,
    id: props.id,
    role: "tabpanel"
  }, props.children);
};
var Tab = {
  Content: Content,
  Item: Item,
  List: List,
  Wrapper: Wrapper
};

var _excluded = ["avoidHeader", "children", "className"];
var WorkArea = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var avoidHeader = _ref.avoidHeader,
    children = _ref.children,
    className = _ref.className,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var wrapperClass = classnames('WorkArea', className, {
    'WorkArea-avoidHeader': avoidHeader
  });
  return React__default.createElement("div", _extends({}, rest, {
    className: wrapperClass,
    ref: ref
  }), children);
});
WorkArea.displayName = 'WorkArea';

export { BasketButton, ButtonVariant, EmptyText, Grid, Highlight, ImageCard, Loading, MaxWidthConstraint, Modal, ModalCloseButton, ModalWrapper, OneByFourGrid, OneByThreeGrid, OvalButton, PhotoHero, Spacer, Tab, WorkArea };
//# sourceMappingURL=components.esm.js.map
